import type { SpringboardCategoryItemDto } from '../api/springboard-categories.api';
import type { SpringBoardPage } from './tabs';

const customOr = (value: string | null | undefined, fallback: string): string =>
  value?.trim() ? value : fallback;

export const mergeSpringboardTabs = (
  defaults: SpringBoardPage[],
  customization?: SpringboardCategoryItemDto[],
): SpringBoardPage[] => {
  if (!customization?.length) {
    return defaults;
  }

  const byId = new Map(customization.map((category) => [category.id, category]));

  return defaults.map((tab) => {
    const override = byId.get(tab.id as SpringboardCategoryItemDto['id']);
    if (!override) {
      return tab;
    }

    // Getters, so a field left unset keeps following the language like the default does.
    return {
      ...tab,
      get label() {
        return customOr(override.label, tab.label);
      },
      get subtitle() {
        return customOr(override.subtitle, tab.subtitle);
      },
      get description() {
        return customOr(override.description, tab.description);
      },
    };
  });
};

export const getSpringboardTabByIdMerged = (
  tabs: SpringBoardPage[],
  id: string | undefined,
): SpringBoardPage | undefined => tabs.find((tab) => tab.id === id);
